
export default (str) => {
  return str ? str.replace(/\n/g, '<br>').replace(/\t/g, '&nbsp;&nbsp;') : null
}
